import React from 'react';

import {
  FourriereDto,
  FourriereViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';
import { FourriereFormValues } from 'types/referentiels/Fourriere';

import { buildFormValues, buildRequestDto } from '../utils';

import ModalEditionFourriere from './ModalEditionFourriere';

interface ModalUpdateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
  fourriere: FourriereDto;
}

function ModalUpdate({
  close,
  visible,
  refreshDashboard,
  fourriere,
}: ModalUpdateProps): React.ReactElement {
  const initials: FourriereFormValues = buildFormValues(fourriere);
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: FourriereFormValues) =>
      AdminFonctionnelControllerApi.updateFourriereUsingPUT(
        fourriere.idCorrelation,
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (field: FourriereViolationDtoFormFieldEnum, values: FourriereFormValues) =>
      AdminFonctionnelControllerApi.validateUpdateFourriereFieldUsingPOST(
        field,
        fourriere.idCorrelation,
        buildRequestDto(values),
      ),
    response => response.fourriereViolationsDto ?? [],
  );

  return (
    <ModalEditionFourriere
      close={close}
      visible={visible}
      title="Mise à jour de la fourrière"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
      additionalInputs={[
        {
          field: FourriereViolationDtoFormFieldEnum.ID_ALIENATION,
          name: 'idAlienation',
          tooltipProps: {
            title:
              'Attention: toute modification de cet ID créé par la DNID aura des conséquences sur les flux de remises de véhicules à vendre.',
            trigger: ['focus'],
            placement: 'top',
          },
          label: 'Id Alienation',
        },
      ]}
    />
  );
}

export default ModalUpdate;
